/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ListBlueprintDetails {
    getFixupPrototypeFunction() { return ListBlueprintDetails.fixupPrototype; }

    static newInstance(model: Partial<ListBlueprintDetails>): ListBlueprintDetails {
        let obj = Object.assign(new ListBlueprintDetails(), model);
        ListBlueprintDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ListBlueprintDetails>): ListBlueprintDetails {
        if (!model) return null;
        return ListBlueprintDetails.newInstance(<ListBlueprintDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ListBlueprintDetails) {
        if (!obj) return;

        models.ListBlueprintDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ListBlueprintDetails): boolean {
        Object.setPrototypeOf(obj, ListBlueprintDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.page_count === undefined) {
            this.page_count = 0;
        }
        if (this.total_count === undefined) {
            this.total_count = 0;
        }
        if (this.blueprints) {
            for (let val of this.blueprints) {
                models.BlueprintDetails.fixupPrototype(val);
            }
        }
    }

    /**
     * Page count
     */
    page_count: number;

    /**
     * Total count
     */
    total_count: number;

    /**
     * Blueprints Details
     */
    blueprints: Array<models.BlueprintDetails>;

}
